var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.334473,
    width: 40,
    height: 40,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 21.0789V26.5946H25.2713V21.4152C25.2713 20.1372 24.8004 19.2627 23.657 19.2627C22.7825 19.2627 22.2444 19.8681 22.0426 20.4062C21.9753 20.608 21.9081 20.8771 21.9081 21.2134V26.5946H18.6794C18.6794 26.5946 18.7466 17.8502 18.6794 16.9757H21.9081V18.321C22.3117 17.6484 23.1188 16.7067 24.8004 16.7067C26.8856 16.7067 28.5 18.1192 28.5 21.0789ZM15.3161 12.3345C14.2399 12.3345 13.5 13.0744 13.5 14.0161C13.5 14.9578 14.1726 15.6977 15.2489 15.6977C16.3924 15.6977 17.065 14.9578 17.065 14.0161C17.1323 13.0071 16.4596 12.3345 15.3161 12.3345ZM13.7018 26.5946H16.9305V16.9757H13.7018V26.5946Z",
    fill: "#004B7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d35dc94e5eebd8f545d7a4ffaab9dd02.svg";
export { ForwardRef as ReactComponent };